import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { ActivatedRoute, Router } from '@angular/router';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { sleep, venueAcceptsOrders } from '../../../smoothr-web-app-core/utils/utils';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import Address from '../../../smoothr-web-app-core/models/Address';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { NavigationService } from 'src/app/services/navigation.service';
import { MapPage } from '../map/map.page';
import { PopoverController } from '@ionic/angular';
import { SelectLanguagePopoverComponent } from 'src/app/components/select-language-popover/select-language-popover.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { MenuPage } from '../menu/menu.page';
import { Subscription } from 'rxjs';

enum Language {
	GreatBritain = 'en',
	German = 'de',
}

@Component({
	selector: 'app-home',
	templateUrl: './home.page.losteria.html',
	styleUrls: ['./home.page.losteria.scss'],
})
export class HomePage extends RepositoryDirective implements OnInit {
	static url = 'home';
	static urlHome = 'account';
	static scanUrl = 'venue/:venueId/table/:tableNumber';

	environment = environment;

	loading = false;
	preorderTypes = [PreorderType.INSIDE, PreorderType.TAKE_AWAY];
	active: any = {};
	opened = false;
	selectedLanguage = this.translate.currentLang;
	currentYear = new Date().getFullYear();

	private langSub$: Subscription;

	constructor(
		protected repository: RepositoryService,
		private router: Router,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private route: ActivatedRoute,
		private popover: PopoverController,
		private snackBar: MatSnackBar
	) {
		super(repository);
	}

	// static async navigate(router: Router, repository?: RepositoryService) {
	// 	if (repository) {
	// 		repository.resetVenue();
	// 		repository.address.emit(null);
	// 		repository.order.emit(null);
	// 		repository.verifiedOrder.emit(null);
	// 		repository.payment.emit(null);
	// 	}

	// 	await router.navigateByUrl(HomePage.url);
	// }

	ngOnInit() {
		super.ngOnInit();
		this.loading = true;
		this.route.paramMap.subscribe(params => {
			console.log(params, params.get('tableNumber'));
			if (params && params.get('tableNumber') && params.get('venueId')) {
				if (params.get('tableNumber') !== 'take_away') {
					console.log(params.get('tableNumber'), params.get('venueId'));
					this.loadVenueByQrCode(params.get('tableNumber'), params.get('venueId'));
				}
			}
		});

		this.langSub$ = this.translate.onLangChange.subscribe(e => (this.selectedLanguage = e.lang));
	}

	ionViewDidEnter() {
		if (history.state.navigationId === 1) {
			this.repository.onOrderChange(null);
		}
		this.repository.verifiedOrder.emit(null);
		this.repository.address.emit(null);
	}

	async locateAndShowStores() {
		await MapPage.navigate(this.router);
	}

	async loadVenueAndCreateOrder(venue: Venue, address: Address, preorderType: PreorderType) {
		console.log('loadVenueAndCreateOrder(', venue, address, preorderType, ')');
		const loadedVenue = await this.repository.getVenue(venue._id);
		this.repository.createOrder(loadedVenue, address, OrderType.PREORDER, preorderType);
		await this.navigationService.menu();
		this.loading = false;
	}

	loadVenues() {
		for (const preorderType of this.preorderTypes) {
			this.active[preorderType] = false;
		}
		new Promise<void>(async (resolve, reject) => {
			try {
				const venues = await this.repository.getAllVenues(environment.customerGroup);
				for (const venue of venues) {
					for (const preorderType of this.preorderTypes) {
						this.active[preorderType] = this.active[preorderType] || venueAcceptsOrders(venue, preorderType);
					}
				}
				resolve();
			} catch (e) {
				reject(e);
			}
		}).finally(() => (this.loading = false));
	}
	async goToMenu(type: PreorderType) {
		this.locateAndShowStores();
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}

	async openPopoverLanuage(ev: any) {
		console.log(ev);

		this.opened = true;
		const popover = await this.popover.create({
			component: SelectLanguagePopoverComponent,
			cssClass: 'popover-home',
			event: ev,
			translucent: true,
			showBackdrop: false,
			side: 'top',
			alignment: 'end',
			reference: 'event',
			componentProps: {
				lang: this.translate.currentLang,
			},
		});
		popover.onWillDismiss().then(v => {
			console.log(v);
			if (v.data) {
				this.translate.setDefaultLang(v.data);
				this.translate.use(v.data);
				this.selectedLanguage = v.data;
			}

			this.opened = false;
		});
		await popover.present();

		return;
	}

	selectedImage() {
		return '../../../assets/' + this.selectedLanguage + '.svg';
	}
	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}

	async loadVenueByQrCode(tableNumber: string, venueId: string) {
		this.loading = true;
		try {
			const venueData = await this.repository.getVenue(venueId);
			console.log('venueData', venueData);

			const table = (await Api.getTable(this.venue._id, tableNumber)).data as any;
			await sleep(100);

			if (venueData && table) {
				if (!table?.active) {
					this.loading = false;
					this.snackBar.open(this.translate.instant('home_page.scan_table_error'), null, {
						duration: 2000,
					});
					return;
				}
				this.repository.venue.emit(venueData);
				this.repository.createOrder(this.venue, null, OrderType.PREORDER, PreorderType.INSIDE);
				this.order.tableNumber = table.number;
				this.order.table = table._id;
				this.order.pendingCashPaymentEnabled = table.pendingCashPaymentEnabled || false;
				this.order.openOrdersEnabled = table.openOrdersEnabled || false;
				this.repository.onOrderChange(this.order);
				sleep(200);
				await MenuPage.navigate(this.router);
			}
			this.loading = false;
		} catch (e) {
			this.snackBar.open(this.translate.instant('home_page.scan_table_error'), null, {
				duration: 2000,
			});
			this.loading = false;
		}
	}

	ngOnDestroy() {
		this.langSub$?.unsubscribe();
	}
}
